import * as S from './style';

const Loading = () => {
  return (
    <S.LoadingContainer>
      <S.Spinner />
    </S.LoadingContainer>
  );
};

export default Loading;
